import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

import { IHandleToggleParams } from './toggle-slider.model';

@Component({
  selector: 'app-opin-toggle-slider',
  templateUrl: './toggle-slider.component.html',
  styleUrls: ['./toggle-slider.component.scss'],
  standalone: false
})
export class OpinToggleSliderComponent {
  @Input() isChecked: boolean;
  @Input() name: string;

  @Output() onToggle = new EventEmitter<IHandleToggleParams>();

  handleToggle({ checked }: MatSlideToggleChange): void {
    this.onToggle.emit({
      isChecked: checked,
      name: this.name
    });
  }
}
